import fileSaver from 'file-saver'
import Vue from 'vue'
const requests = {
  fileUploading: null
}

export default {
  getTerschemaList({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.terschema, {
        params: {
          limit: 2000,
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setDocumentsList', r.body.results)
      })
  },
  getControlsList({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.control, {
        params: {
          limit: 2000,
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setDocumentsList', r.body.results)
      })
  },
  generateReport({ commit, getters }, params) {
    return Vue.http
      .post(getters.endpoint.generateReport, params, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setReportsList', r.body.results || r.body)
      })
  },
  addTerschema({ commit, dispatch, getters }, params) {
    const multipart = new FormData()
    multipart.append('file', params.file)
    multipart.append('name', params.name)
    multipart.append('show', params.show)
    multipart.append('workspace', getters.workspace)
    return Vue.http.post(getters.endpoint.terschema, multipart).then((r) => {
      const updList = getters.documentsList.concat([])
      updList.push(r.body)
      commit('setDocumentsList', updList)
    })
  },
  addControl({ commit, dispatch, getters }, params) {
    const multipart = new FormData()
    multipart.append('file', params.file)
    multipart.append('name', params.name)
    multipart.append('show', params.show)
    multipart.append('workspace', getters.workspace)
    return Vue.http.post(getters.endpoint.control, multipart).then((r) => {
      const updList = getters.documentsList.concat([])
      updList.push(r.body)
      commit('setDocumentsList', updList)
    })
  },
  updateTerschema({ commit, dispatch, getters }, params) {
    const multipart = new FormData()
    if (params.file) {
      multipart.append('file', params.file)
    }
    multipart.append('name', params.name)
    multipart.append('show', params.show)
    return Vue.http
      .patch(getters.endpoint.terschemaById(params.id), multipart, {
        params: {
          workspace: getters.workspace
        }
      })
      .then((r) => {
        const updList = getters.documentsList.concat([])
        const currentIndex = updList.findIndex((v) => v.id === params.id)
        if (currentIndex > -1) {
          updList[currentIndex] = r.body
          commit('setDocumentsList', updList)
        }
      })
  },
  updateControl({ commit, dispatch, getters }, params) {
    const multipart = new FormData()
    if (params.file) {
      multipart.append('file', params.file)
    }
    multipart.append('name', params.name)
    multipart.append('show', params.show)
    return Vue.http
      .patch(getters.endpoint.controlById(params.id), multipart, {
        params: {
          workspace: getters.workspace
        }
      })
      .then((r) => {
        const updList = getters.documentsList.concat([])
        const currentIndex = updList.findIndex((v) => v.id === params.id)
        if (currentIndex > -1) {
          updList[currentIndex] = r.body
          commit('setDocumentsList', updList)
        }
      })
  },
  deleteTerschema({ commit, dispatch, getters }, id) {
    return Vue.http
      .delete(getters.endpoint.terschemaById(id), {
        params: {
          workspace: getters.workspace
        }
      })
      .then((r) => {
        const updList = getters.documentsList.filter((v) => v.id !== id)
        commit('setDocumentsList', updList)
      })
  },
  deleteControl({ commit, dispatch, getters }, id) {
    return Vue.http
      .delete(getters.endpoint.controlById(id), {
        params: {
          workspace: getters.workspace
        }
      })
      .then((r) => {
        const updList = getters.documentsList.filter((v) => v.id !== id)
        commit('setDocumentsList', updList)
      })
  },
  getReportsList({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.reportsList, {
        params: {
          limit: 2000,
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setReportsList', r.body.results || r.body)
      })
  },
  getReportFile({ commit, getters }, params) {
    return Vue.http
      .get(getters.endpoint.report, {
        responseType: 'blob',
        params: {
          workspace: getters.workspace,
          version: getters.version,
          ids: params.ids.join(','),
          workspace_diff: params.workspace
        }
      })
      .then((r) => {
        fileSaver.saveAs(r.body, params.ids.length > 1 ? 'reports.zip' : params.name)
      })
  },
  getReportExcelFile({ commit, getters }, file) {
    return Vue.http
      .get(file, {
        responseType: 'blob'
      })
      .then((r) => {
        return r.data
      })
  },
  clearReports({ commit }) {
    commit('setReportsList', [])
  },
  clearDocuments({ commit }) {
    commit('setDocumentsList', [])
  }
}



// WEBPACK FOOTER //
// ./src/store/documents/actions.js